import React from 'react';

const Spinner = () => {
    return <span className="fa fa-spinner fa-fw fa-spin mar-r-1"></span>;
};

export default Spinner;
